"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSpanIO = void 0;
var parser_1 = require("./parser");
Object.defineProperty(exports, "normalizeSpanIO", { enumerable: true, get: function () { return parser_1.normalizeSpanIO; } });
